import { WarningCircle, X } from '@phosphor-icons/react';
import classNames from 'classnames';
import React from 'react';

export enum AlertType {
  Notice = 'notice',
  Warning = 'warning',
  Danger = 'danger',
  Success = 'success',
}

interface Props {
  text?: string;
  type: AlertType;
  onClose?: () => void;
}

export function Alert({ type, text, onClose }: Props): JSX.Element {
  return (
    <div
      className={classNames('relative flex items-center p-4 mb-4 border-t-4 rounded-lg', {
        'text-blue-800 border-blue-300 bg-blue-100 dark:text-blue-400 dark:bg-gray-700 dark:border-blue-800': type === AlertType.Notice,
        'text-yellow-800 border-yellow-300 bg-yellow-100 dark:text-yellow-300 dark:bg-gray-700 dark:border-yellow-800':
          type === AlertType.Warning,
        'text-red-800 border-red-300 bg-red-100 dark:text-red-400 dark:bg-gray-700 dark:border-red-800': type === AlertType.Danger,
        'text-green-800 border-green-300 bg-green-100 dark:text-green-400 dark:bg-gray-700 dark:border-green-800':
          type === AlertType.Success,
      })}
      role='alert'
    >
      {onClose !== undefined && (
        <button className='absolute z-999 right-0 top-0 p-2' onClick={onClose}>
          <X />
        </button>
      )}

      <WarningCircle className='flex-shrink-0 w-4 h-4' size={32} weight='fill' />
      <p className='ms-3 text-sm font-medium'>{text}</p>
    </div>
  );
}
